import { appMounted } from 'duck/actions'
import { callApi } from 'duck/operations'
import { EntityId } from 'entities-next/common'
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { loginWithEmail } from 'scenes/Account/duck/actions'
import { ActionType, getType } from 'typesafe-actions'

import { fetchCurrentUser, logoutBegin, logoutSuccess } from './actions'
import { getCurrentUser, getCurrentUserId } from './selectors'
import { removeToken, storeToken } from './utils'
import { getApiUserHandlers, User } from '../../entities-next/user'

export function* authSaga() {
  yield all([
    takeLatest(getType(appMounted), fetchCurrentUserIfPossible),
    takeLatest(getType(fetchCurrentUser.request), fetchCurrentUserEffect),
    takeEvery(getType(loginWithEmail.success), loginEffect),
    takeLatest(getType(logoutBegin), logoutEffect),
  ])
}

function* fetchCurrentUserIfPossible() {
  const currentUserId: EntityId = yield select(getCurrentUserId)
  const currentUser: User = yield select(getCurrentUser)
  if (currentUserId && !currentUser) {
    yield put(fetchCurrentUser.request(currentUserId))
  }
}

function* loginEffect(action: ActionType<typeof loginWithEmail.success>) {
  const { userId, token } = action.payload
  yield call(storeToken, token)
  yield put(fetchCurrentUser.request(userId))
}

function* fetchCurrentUserEffect(action: ActionType<typeof fetchCurrentUser.request>) {
  const userId = action.payload
  const { apiGetUser } = getApiUserHandlers()
  try {
    const user: User = yield callApi(apiGetUser, userId)
    yield put(fetchCurrentUser.success(user))
  } catch (error) {
    yield put(fetchCurrentUser.failure(error))
    throw error
  }
}

function* logoutEffect() {
  yield call(removeToken)
  yield put(logoutSuccess())
}
